export enum PopupTypes {
  NONE = 'NONE',
  INCIDENTS = 'INCIDENTS',
  TRIPS = 'TRIPS',
}
